// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: "project-netflix-ai.firebaseapp.com",
  projectId: "project-netflix-ai",
  storageBucket: "project-netflix-ai.firebasestorage.app",
  messagingSenderId: "902559307821",
  appId: "1:902559307821:web:70462ac6c44be9e4b540a4",
  measurementId: "G-P08QTWT0V9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

export const auth = getAuth(app);
